import { IconButton, Tooltip } from "@material-ui/core";

import BotonSeleccionar from "./BotonSeleccionar";
import { Fragment } from "react";
import MeditocActions from "../../../utils/MeditocActions";
import MeditocModalFull from "../../../utils/MeditocModalFull";
import ModuloPerfil from "./ModuloPerfil";
import ModuloSeleccionar from "./ModuloSeleccionar";
import RefreshIcon from "@material-ui/icons/Refresh";
import SettingsIcon from "@material-ui/icons/Settings";
import Simbologia from "../sistema/Simbologia";
import SubmoduloSeleccionar from "./SubmoduloSeleccionar";
import { useLogin } from "../../../../context/LoginContext";
import { usePerfil } from "../../../../context/PerfilContext";

export default function AdministrarPerfil() {
    const {
        listaSistemaModulos,
        listaPermisosPerfil,
        perfilSeleccionado,
        modalOpenAdministrarPerfil,
        handleOpenAdministrarPerfil,
        handleClickRefrescarPermisos,
        handleClickSeleccionarModulos,
    } = usePerfil();
    const { usuarioPermisos } = useLogin();
    const permisos = usuarioPermisos["1"].Submodulos["2"];

    return (
        <Fragment>
            <MeditocModalFull
                open={modalOpenAdministrarPerfil}
                setopen={handleOpenAdministrarPerfil}
                title={"Administrar permisos para " + perfilSeleccionado.sNombre}
            >
                <MeditocActions title="Accesos permitidos">
                    {permisos.Botones["6"] !== undefined && ( //Agregar permisos a módulos de Meditoc CallCenter
                        <Tooltip title={permisos.Botones["6"].Nombre} arrow>
                            <IconButton onClick={handleClickSeleccionarModulos}>
                                <SettingsIcon className="color-1" />
                            </IconButton>
                        </Tooltip>
                    )}
                    {permisos.Botones["12"] !== undefined && ( //Actualizar información
                        <Tooltip title={permisos.Botones["12"].Nombre} arrow>
                            <IconButton onClick={handleClickRefrescarPermisos}>
                                <RefreshIcon className="color-1" />
                            </IconButton>
                        </Tooltip>
                    )}
                </MeditocActions>
                {listaPermisosPerfil.length > 0 ? (
                    listaPermisosPerfil.map((modulo) => (
                        <ModuloPerfil
                            key={modulo.iIdModulo}
                            modulo={modulo}
                            submodulosSistema={
                                listaSistemaModulos.find((x) => x.iIdModulo === modulo.iIdModulo).lstSubModulo
                            }
                        />
                    ))
                ) : (
                    <div className="color-3 center">
                        (Este perfil no tiene ningún permiso para acceder a los módulos de Meditoc CallCenter)
                    </div>
                )}
                <Simbologia />
            </MeditocModalFull>
            <ModuloSeleccionar />
            <SubmoduloSeleccionar />
            <BotonSeleccionar />
        </Fragment>
    );
}
